import { PageHeader, Typography } from 'antd';
import { Component } from 'react';
import { isStatisticsMode, STATISTICS_APP_TITLE } from '../config/settings';
import authService from './api-authorization/AuthorizeService';
import StatisticsGuide from './statistics-guide';

const { Link } = Typography;

interface Props {}

export class Home extends Component<Props> {
    static displayName = Home.name;

    renewToken = (): void => authService.renewToken();

    render() {
        let isDev = process.env.NODE_ENV.toUpperCase() === 'DEVELOPMENT';
        const statisticsMode = isStatisticsMode();

        return (
            <div>
                <PageHeader
                    title={
                        statisticsMode ? STATISTICS_APP_TITLE : 'Welcome to Total Waterpolo Arena!'
                    }
                    style={{ padding: '16px 0px' }}
                />

                {statisticsMode && <StatisticsGuide />}

                {isDev && (
                    <>
                        <Link href="https://localhost:44347/swagger" target="_blank">
                            OpenAPI Specification
                        </Link>
                        <br></br>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <Link onClick={() => this.renewToken()}>Refresh token</Link>
                    </>
                )}
            </div>
        );
    }
}
